import React from 'react';

const ValueContext = React.createContext({ test: 123, changeTest: () => {} });

export default ValueContext;
